import { FC, useState } from 'react';
import { deleteCookie } from '@doda/common/src/utils/cookieUtil';
import { COOKIE } from '@doda/common/src/constants/cookie';
import { JobSearchResultResponse } from '@doda/api-client/aspida/@types';
import { ConfirmDisplay } from '../ConfirmDisplay';
import { EmptyDisplay } from '../EmptyDisplay';
import { ACCORDION_ITEMS } from '../../constants';
import { HistoryJobsContents } from '../HistoryJobsContents';

/**
 * 最近見た求人 アコーディオンメニュー
 * @param historyList 検索された求人のリスト
 * @param updateHistoryList 最近見た求人データ更新関数
 * @param onClickMenuClose 閉じるボタンのクリックイベント
 * @param loginStatus ログイン状態
 */
export interface HistoryJobsProps {
  historyList: JobSearchResultResponse[];
  onClickMenuClose: () => void;
  updateHistoryList: (list: JobSearchResultResponse[]) => void;
  loginStatus: boolean;
}

export const HistoryJobs: FC<HistoryJobsProps> = ({
  historyList,
  onClickMenuClose,
  updateHistoryList,
  loginStatus,
}) => {
  const [isShowConfirm, setIsShowConfirm] = useState(false);

  // 削除確認画面の表示
  const onClickShowConfirm = () => {
    setIsShowConfirm(true);
  };

  // 「最近見た求人」一括削除
  const onClickAllDeleteHistory = () => {
    deleteCookie(COOKIE.HISTORYID);
    updateHistoryList([]);
    onClickMenuClose();
    // メニューを閉じるまで確認画面を表示
    setTimeout(() => {
      setIsShowConfirm(false);
    }, 300);
  };

  if (!historyList.length) {
    return (
      <EmptyDisplay
        label={ACCORDION_ITEMS.historyJobs.label}
        onClick={onClickMenuClose}
      />
    );
  }

  return (
    <>
      {!isShowConfirm ? (
        <HistoryJobsContents
          historyList={historyList}
          loginStatus={loginStatus}
          onClickShowConfirm={onClickShowConfirm}
          updateHistoryList={updateHistoryList}
        />
      ) : (
        <ConfirmDisplay
          label={ACCORDION_ITEMS.historyJobs.label}
          onClickDelete={onClickAllDeleteHistory}
          setIsShowConfirm={setIsShowConfirm}
        />
      )}
    </>
  );
};
